module.exports = __webpack_public_path__ + "93442570e91ccd2ef8852fdce4d2a0b1.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_analytics/icons/total_potential_exposure.png
// module id = 3314
// module chunks = 69